import CircularProgress from '@mui/material/CircularProgress';

const LoadCircular = () => {
    return(
        <CircularProgress style={{marginLeft: "10px"}} color="inherit" size={30}/>
    )
}

export default LoadCircular;